import { combineReducers }          from 'immutable-reducers';
import { routeReducer }             from 'redux-simple-router';
import { fromJS }                   from 'immutable';
import { reducer as formReducer }   from 'redux-form';

import { profileReducer, licensePlatesReducer } from './profile/reducers';
import { visitsReducer, visitReducer, timeSlotsReducer, timeSlotConfigReducer, unitVerificationReducer, goodsReducer, docsReducer } from './visits/reducers';
import { authReducer }              from './auth/reducers';
import { sessionReducer }           from './app/reducers';
import { reportsReducer }           from './reports/reducers';

const immutableize = (path, reducer) => (state, action) => {
    let response = reducer(state.getIn(path).toJS(), action);
    if (state === response) {
        return state;
    }
    return state.setIn(path, fromJS(response));
};
const immutableFormReducer = immutableize(['form'], formReducer);
const immutableRouteReducer = immutableize(['route'], routeReducer);

const reducers = [
    profileReducer,
    visitsReducer,
    visitReducer,
    timeSlotsReducer,
    timeSlotConfigReducer,
    licensePlatesReducer,
    authReducer,
    sessionReducer,
    unitVerificationReducer,
    immutableFormReducer,
    immutableRouteReducer,
    goodsReducer,
    docsReducer,
    reportsReducer
];

const rootReducer = combineReducers(...reducers);

export default rootReducer;